import CacheUser from "@/assets/models/CacheUser";

let fukuan = {
    type: '',
    subTitle: '',
    bumen: '',
    shoukuan: '',
    zhanghao: '',
    kaihuhang: '',
    jine: '',
    currency: '人民币',
    jineDaxie: '',
    zhuguan: '', // 审核 -> 对应部门主管
    userId: null, // 发起流程的用户ID
    caiwu: '',
    yuanyin: '',
    fukuanNeirong: '',
    zi: '',
    hao: '',
    caigouNeirong: '',
    caigouQingdanGyl: [{
        name: '',
        danjia: '',
        shuliang: ''
    }],
    tuiguangNeirong: '',
    zujinShuidianYear: '',
    zujinShuidianMonth: '',
    serverZhanghao: '', // 服务器账号
    fuwushang: '', // 服务商
    fujians: [],
    createDate: '',
    startUser: {},
    yunyingjingliUser: {},
    zhuguanUser: {},
    zhuguanUserCaigou: {},
    zongjingbanUserCaigou: {},
    caiwuUser: CacheUser.caiwu,
    caiwujingliUser: CacheUser.caiwujingli,
    zongjingbanUser: CacheUser.zongjingban,
    chunaUser: CacheUser.chuna,
    serverUser: CacheUser.server,
    qianshouUser: null,
    kuanxiangsGz: [{
        payAccount: '',
        jine: '',
        bumen: ''
    }],
    chaosongUser: null,
    chaosongsUser: [],
    fukuanPizhu: ''
}
let baoxiao = {
    yongtus: [{
        name: '',
        jine: ''
    }],
    lingkuanren: '',
    type: '',
    subTitle: '',
    bumen: '',
    jineDaxie: '',
    heji: 0,
    currency: '人民币',
    yuanjiekuan: '',
    yingtuikuan: '',
    beizhu: '',
    zi: '',
    hao: '',
    fujians: [],
    createDate: '',
    startUser: {},
    yunyingjingliUser: {},
    zhuguanUser: {},
    caiwuUser: CacheUser.caiwu,
    caiwujingliUser: CacheUser.caiwujingli,
    zongjingbanUser: CacheUser.zongjingban,
    chunaUser: CacheUser.chuna,
    chaosongUser: null,
    fukuanPizhu: ''
}
let jiesuan = {
    kuanxiangs: [{
        name: '',
        jine: '',
        bumen: ''
    }],
    jiesuanYear: '',
    jiesuanMonth: '',
    title: '周期结算',
    type: '',
    subTitle: '',
    bumen: '',
    jineDaxie: '',
    jine: 0,
    currency: '人民币',
    beizhu: '',
    zi: '',
    fujians: [],
    createDate: '',
    startUser: {},
    zhuguanUser: {},
    chaosongUser: null
}

let renshi = {
    bumen: '',
    zhiwu: '',
    mudi: '',
    startDate: '',
    endDate: '',
    day: '',
    anpai: [],
    fujians: [],
    yuanyin: '',
    jiaotongGo: ['汽车'],
    jiaotongBack: ['汽车'],
    currency: '人民币',
    feiyongYusuan: {
        jiaotong: '',
        zhusu: '',
        canfei: '',
        yewu: '',
        qita: '',
        jine: ''
    },
    feiyongYujie: {
        jiaotong: '',
        zhusu: '',
        canfei: '',
        yewu: '',
        qita: '',
        jine: ''
    },
    jine: '',
    startUser: {},
    zhuguanUser: {},
    renshiUser: {},
    chaosongUser: null,
    fukuanPizhu: ''
}
let caigou = {
    xuhao: '1',
    sku: '',
    leixing: '',
    gongyingshang: '',
    name: '',
    shuliang: '',
    danjia: '',
    yunfei: '',
    heji: '',
    jiandanqudao: '',
    wuliufangshi: '',
    beizhu: ''
};
// 样品采购 备货申请
let yangpincaigouBeihuoshenqing = {
    zi: '',
    bumen: '',
    day: '',
    yuanyin: '',
    jine: 0,
    yunfeijine: 0,
    currency: '人民币',
    startUser: {},
    fujians: [],
    kaifayuanUser: {},
    yunyingUser: {},
    caiwuUser: CacheUser.caiwu,
    caiwujingliUser: CacheUser.caiwujingli,
    lingdaoUser: CacheUser.zongjingban,
    zhuguanUser: {},
    zongjingbanUser: CacheUser.zongjingban,
    caigous: [caigou],
    chunaUser: CacheUser.chuna,
    caigouUser: null,
    chaosongUser: null,
    fukuanPizhu: '',
    // fba备货申请特有
    fbaxianggui: '',
    fahuoxianggui: '',
    danxiangjizhong: '',
    danxiangshuliang: '',
    danxiangchicun: '',
    dingzhidaxiang: '',
    fbaCaigouquerenUser: CacheUser.chuna,
    gongyinglianZhuguanUser: CacheUser.gongyinglianZhuguan
}
// 发货申请
let fahuoshenqing = {
    zi: '',
    bumen: '',
    day: '',
    jine: 0,
    yunfeijine: 0,
    currency: '人民币',
    startUser: {},
    fujians: [],
    caiwuUser: CacheUser.caiwu,
    zhuguanUser: {},
    caigous: [caigou],
    fbaCaigouquerenUser: CacheUser.chuna,
    caigouUser: null,
    chaosongUser: null,
    fukuanPizhu: '',
}
export default {
    fukuan: fukuan,
    baoxiao: baoxiao,
    jiesuan: jiesuan,
    renshi: renshi,
    caigou: caigou,
    yangpincaigouBeihuoshenqing: yangpincaigouBeihuoshenqing,
    fahuoshenqing: fahuoshenqing,
}
